import { type AncapTestCategory, type SafetyFeatureCategory } from '@/types/safety-features';

type SetCacheStateResult<T> = {
  isLoading: boolean;
  hasError: boolean;
  data: T | null;
};

export type CacheState = {
  safetyFeatureCategories: SetCacheStateResult<SafetyFeatureCategory[]>;
  ancapTestCategories: SetCacheStateResult<AncapTestCategory[]>;
};

const state: CacheState = {
  safetyFeatureCategories: {
    isLoading: false,
    hasError: false,
    data: null,
  },
  ancapTestCategories: {
    isLoading: false,
    hasError: false,
    data: null,
  },
};

export default state;
